export default "__VITE_ASSET__DNRScG3S__"